import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, type OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';

@Component({
    selector: 'web-time-picker',
    templateUrl: './web-time-picker.component.html',
    styleUrls: ['./web-time-picker.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, FormsModule, TimepickerModule],
})
export class WebTimePickerComponent implements OnInit {
    @Input() defaultTime: Date;

    public time: Date;

    private initialized = false;

    @Output() timeChange = new EventEmitter<Date>();

    ngOnInit() {
        this.time = this.defaultTime;
    }

    public timeSelectionDone(ev: any): void {
        this.time = ev;

        if (!this.initialized) {
            this.initialized = true;
            return;
        }

        this.timeChange.emit(this.time);
    }
}
